import { render, staticRenderFns } from "./NewsDetail.vue?vue&type=template&id=0c9d3a84"
import script from "../../services/news/news-detail.js?vue&type=script&lang=js&external"
export * from "../../services/news/news-detail.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports